import React, { useState, useEffect } from 'react';
import axios from 'axios';
import updateFormCSS from './updateForm.module.css';
import Loader from '../../loader';
import { axiosAuthFetch, axiosImageAuthFetch } from '../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../constants';
import serviceFormCSS from '../../serviceForm/serviceForm.module.css';
import addProductCSS from '../addProduct/addProduct.module.css';


export function UpdateForm({ product }) {
    const { name, price, description, multipleVoltages, voltageOptions, product_information, category, supplier, varenummer, visible, service_form } = product.attributes;
    const id = product.id;
    console.log('PRODUCT',product.attributes)
    // Product states
    const [productName, setProductName] = useState(name);
    const [productPrice, setProductPrice] = useState(price);
    const [productDescription, setProductDescription] = useState(description);
    const [productVarenummer, setProductVarenummer] = useState(varenummer);
    const [isLoading, setIsLoading] = useState(false);
    const [suppliers, setSuppliers] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(category.data.id);
    const [selectedSupplierId, setSelectedSupplierId] = useState(supplier.data.id);
    const [isVisible, setIsVisible] = useState(visible);
    const [productImage, setProductImage] = useState(product.attributes.image?.data?.attributes?.url || '');
    const [newProductImage, setNewProductImage] = useState(null);
    const [hasMultipleVoltageOptions, setHasMultipleVoltageOptions] = useState(multipleVoltages || false);
    const [newVoltageOptions, setNewVoltageOptions] = useState(voltageOptions ? voltageOptions.map(option => ({ voltage: option.voltage })) : [{ voltage: "" }]);
    const [productDataSheet, setProductDataSheet] = useState(product.attributes.dataSheet?.data?.attributes?.url || '');
    const [newProductDataSheet, setNewProductDataSheet] = useState(null);
    const [productInformationList, setProductInformationList] = useState(
        product_information.map(info => ({ text: info.infoText, value: info.infoValue })) || [{ text: "", value: "" }]
    );
    // Service form states
    const [serviceFormExists, setServiceFormExists] = useState(service_form && service_form.data ? true : false);
    const [serviceFormId, setServiceFormId] = useState(service_form && service_form.data ? service_form.data.id : null);
    const [checks, setChecks] = useState(service_form && service_form.data ? service_form.data.attributes.service_checks.data.map(check => ({
        id: check.id,
        description: check.attributes.description,
        category: check.attributes.category
    })) : [{ id: 1, description: '', category: '' }]);
    const [visualChecked, setVisualChecked] = useState(service_form && service_form.data ? service_form.data.attributes.visual_check : false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [checkCategories, setCheckCategories] = useState([{ id: 1, name: '' }]);
    console.log(productImage, productDataSheet, setProductDataSheet, setProductImage, setServiceFormExists, setServiceFormId);

    useEffect(() => {
        async function fetchSuppliers() {
            try {
                const response = await axios.get('https://renowned-oasis-58a898da10.strapiapp.com/api/suppliers?pagination[pageSize]=100&sort=name:asc');
                setSuppliers(response.data.data);

                const categoryResponse = await axios.get('https://renowned-oasis-58a898da10.strapiapp.com/api/categories?sort=place:asc');
                setCategories(categoryResponse.data.data);

                if (service_form && service_form.data) {
                    const existingChecks = service_form.data.attributes.service_checks.data;
                    const existingCategories = existingChecks.map(check => check.attributes.category).filter(category => category);
    
                    const uniqueCategories = Array.from(new Set(existingCategories));
                    setCheckCategories(uniqueCategories.map((category, index) => ({
                        id: index + 1,
                        name: category
                    })));
                }

            } catch (error) {
                console.error(error);
            }
        }

        fetchSuppliers();
        //eslint-disable-next-line
    }, []);

    const handleSupplierChange = (event) => {
        setSelectedSupplierId(event.target.value);
    };

    const handleCategoryChange = (event) => {
        setSelectedCategoryId(event.target.value);
    };

    const handleProductNameChange = (event) => {
        setProductName(event.target.value);
    };

    const handleProductDescriptionChange = (event) => {
        setProductDescription(event.target.value);
    };

    const handleProductVarenummerChange = (event) => {
        setProductVarenummer(event.target.value);
    };

    

    const handleProductPriceChange = (event) => {
        setProductPrice(event.target.value);
    };

    const handleProductImageChange = (event) => {
        setNewProductImage(event.target.files[0]);
    };
    
    const handleProductDataSheetChange = (event) => {
        setNewProductDataSheet(event.target.files[0]);
    };

    const handleVisibilityChange = () => {
        setIsVisible(!isVisible);
    };

    const handleVoltageOptionsChange = (index, value) => {
        const updatedVoltageOptions = [...newVoltageOptions];
        updatedVoltageOptions[index].voltage = value;
        setNewVoltageOptions(updatedVoltageOptions);
    }
    
    const handleAddVoltageOption = () => {
        setNewVoltageOptions([...newVoltageOptions, { voltage: "" }]);
    }
    
    const handleRemoveVoltageOption = (index) => {
        const updatedVoltageOptions = newVoltageOptions.filter((_, i) => i !== index);
        setNewVoltageOptions(updatedVoltageOptions);
    }

    const handleCheckDescriptionChange = (id, description) => {
        setChecks(prevChecks => {
            const updatedChecks = prevChecks.map(check =>
                check.id === id ? { ...check, description } : check
            );
            return updatedChecks;
        });
    };

    const handleAddCheck = () => {
        const newCheckId = checks.length + 1;
        setChecks([...checks, { id: newCheckId, description: '', category: '' }]);
    };

    const handleCheckCategoryChange = (id, category) => {
        setChecks(prevChecks => {
            const updatedChecks = prevChecks.map(check =>
                check.id === id ? { ...check, category } : check
            );
    
            // If the category is new, add it to checkCategories
            if (category && !checkCategories.find(cat => cat.name === category)) {
                const newCategoryId = checkCategories.length + 1;
                setCheckCategories([...checkCategories, { id: newCategoryId, name: category }]);
            }
    
            return updatedChecks;
        });
    };

    const handleRemoveCheck = (id) => {
        const updatedChecks = checks.filter(check => check.id !== id);
        setChecks(updatedChecks);
    };

    const handleAddCategory = () => {
        if (newCategoryName.trim() !== '') {
            const newCategoryId = checkCategories.length + 1;
            setCheckCategories([...checkCategories, { id: newCategoryId, name: newCategoryName.trim() }]);
            setNewCategoryName(''); // Nullstill input-feltet etter at kategorien er lagt til
        }
    };

    const handleCategoryNameChange = (e) => {
        setNewCategoryName(e.target.value);
    };

    const handleProductInformationChange = (index, field, value) => {
        const newProductInformationList = [...productInformationList];
        newProductInformationList[index][field] = value;
        setProductInformationList(newProductInformationList);
    };

    const handleAddProductInformation = (event) => {
        event.preventDefault();
        setProductInformationList([...productInformationList, { text: "", value: "" }]);
    };

    const handleRemoveProductInformation = (index) => {
        const newProductInformationList = productInformationList.filter((_, i) => i !== index);
        setProductInformationList(newProductInformationList);
    };

    const validateProductInformation = () => {
        return productInformationList.every(info => info.text.length >= 3 && info.value.length >= 3);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        const filteredProductInformationList = productInformationList.filter(info => info.text.trim() !== "" && info.value.trim() !== "");

        if (!validateProductInformation()) {
            setIsLoading(false);
            return;
        }

            const formData = new FormData();

            formData.append('data', JSON.stringify({
                name: productName,
                description: productDescription,
                price: productPrice === '' ? null : parseFloat(productPrice),
                visible: isVisible,
                varenummer: productVarenummer,
                product_information: filteredProductInformationList.map(info => ({
                    infoText: info.text,
                    infoValue: info.value,
                })),
                supplier: selectedSupplierId,
                category: selectedCategoryId,
                multipleVoltages: hasMultipleVoltageOptions,
                voltageOptions: newVoltageOptions.filter(option => option.voltage.trim() !== "")
            }));

            if(newProductImage) {
                formData.append('files.image', newProductImage);
            }

            if(newProductDataSheet) {
                formData.append('files.produktKatalog', newProductDataSheet);
            }

            try{
                const response = await axiosImageAuthFetch(`${API_BASE_URL}/products/${id}`, formData , 'PUT');
                console.log(response);

            const checkIDs = [];
            for (const check of checks) {
                try {
                    const checkID = await createCheck(check.description, check.category);
                    checkIDs.push(checkID);
                } catch (error) {
                    console.error(error);
                }
            }

            if (serviceFormExists) {
                await updateServiceForm(serviceFormId, product.id, checkIDs);
                for (const checkID of checkIDs) {
                    try {
                        await createServiceAction(checkID, serviceFormId);
                    } catch (error) {
                        console.error(error);
                    }
                }
            } else {
                const createdServiceForm = await createServiceForm(product.id, checkIDs);
                const serviceFormId = createdServiceForm.id;
                for (const checkID of checkIDs) {
                    try {
                        await createServiceAction(checkID, serviceFormId);
                    } catch (error) {
                        console.error(error);
                    }
                }
            }

            setIsLoading(false);
            alert('Produkt oppdatert!');
            window.location.href = "/VP/admin/nettbutikk";

        } catch (error) {
            console.error('Feil ved opplasting av bilde eller innsending av skjemadata:', error);
            setIsLoading(false);
        }
    };

    const createCheck = async (description, category) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-checks`, {
                data: {
                    description: description,
                    category: category,
                }
            }, 'POST');
            return response.data.id;
        } catch (error) {
            console.error(error);
        }
    };

    const createServiceForm = async (productID, checkIDs) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-forms`, {
                data: {
                    visual_check: false,
                    product: productID,
                    service_checks: {
                        connect: checkIDs
                    }
                }
            }, 'POST');
            return response.data;
        } catch (error) {
            console.error(error);
        }
    };

    const createServiceAction = async (checkID, formID) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-actions`, {
                data: {
                    completed: false,
                    service_check: {
                        connect: [checkID]
                    },
                    service_form: {
                        connect: [formID]
                    }
                }
            }, 'POST');
            return response.data.id;
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    const updateServiceForm = async (serviceFormId, productID, checkIDs) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-forms/${serviceFormId}`, {
                data: {
                    product: productID,
                    visual_check: visualChecked,
                    service_checks: {
                        set: checkIDs
                    },
                }
            }, 'PUT');
            return response.data;
        } catch (error) {
            console.error(error);
        }
    };

    const handleMulitpleVoltages = () => {
        setHasMultipleVoltageOptions(!hasMultipleVoltageOptions);
    }

    return (
            <div>
                {isLoading && <Loader />}
                <div className={updateFormCSS.p}>
                    <h2>Oppdater produkt</h2>
                </div>
                <form className={updateFormCSS.form} onSubmit={handleSubmit}>
                    <input
                        className={updateFormCSS.input}
                        type="text"
                        value={productName}
                        onChange={handleProductNameChange}
                        placeholder="Produktnavn"
                        required
                    />
                    <textarea
                        className={updateFormCSS.textAreaInput}
                        type="text"
                        value={productDescription}
                        onChange={handleProductDescriptionChange}
                        placeholder="Produktbeskrivelse"
                        rows={7}
                    />
                    <input
                        className={updateFormCSS.input}
                        type="text"
                        value={productPrice}
                        onChange={handleProductPriceChange}
                        placeholder="Pris"
                    />
                    <input
                        className={updateFormCSS.input}
                        type="text"
                        value={productVarenummer}
                        onChange={handleProductVarenummerChange}
                        placeholder="Varenummer"
                    />
                    <select
                        className={updateFormCSS.select}
                        value={selectedSupplierId}
                        onChange={handleSupplierChange}
                        required
                    >
                        <option value="">Velg leverandør</option>
                        {suppliers.map(supplier => (
                            <option key={supplier.id} value={supplier.id}>{supplier.attributes.name}</option>
                        ))}
                    </select>
                    <select
                        className={updateFormCSS.select}
                        value={selectedCategoryId}
                        onChange={handleCategoryChange}
                        required
                    >
                        <option value="">Velg kategori/plassering</option>
                        {categories.map(category => (
                            <option key={category.id} value={category.id}>{category.attributes.place}</option>
                        ))}
                    </select>
                    <div className={updateFormCSS.visibilityContainer}>
                        <div className={updateFormCSS.visibilityChild1}>
                            Synlig i nettbutikken
                        </div>
                        <div
                            className={`${updateFormCSS.visibilityChild2} ${isVisible ? updateFormCSS.checked : ''}`}
                            onClick={handleVisibilityChange}
                        >
                            <div className={updateFormCSS.visibilityButton}></div>
                        </div>
                    </div>
                    <div className={updateFormCSS.formGroupI}>
                        <label>Produktbilde</label>
                        <input className={updateFormCSS.upload} type="file" onChange={handleProductImageChange} />
                    </div>

                    <div className={updateFormCSS.formGroupI}>
                        <label>Datablad</label>
                        <input className={updateFormCSS.upload} type="file" onChange={handleProductDataSheetChange} />
                    </div>
                    <h3 className={updateFormCSS.h3}>Teknisk info</h3>
                    {productInformationList.map((info, index) => (
                    <div key={index} className={addProductCSS.inputGroup}>
                        <div className={addProductCSS.inputSub}>
                            <input
                                className={updateFormCSS.input}
                                type="text"
                                value={info.text}
                                onChange={(e) => handleProductInformationChange(index, "text", e.target.value)}
                                placeholder="Type"
                            />
                            <input
                                className={updateFormCSS.input}
                                type="text"
                                value={info.value}
                                onChange={(e) => handleProductInformationChange(index, "value", e.target.value)}
                                placeholder="Verdi"
                            />
                        </div>
                        <button className={serviceFormCSS.removeButton} type="button" onClick={() => handleRemoveProductInformation(index)}>Fjern</button>
                    </div>
                ))}
                <button className={`${serviceFormCSS.addButton2} bg-success text-white`} type="button" onClick={handleAddProductInformation}>Legg til ny teknisk info</button>
                <div className={addProductCSS.spenningsContainer}>
                    <h3 className={addProductCSS.h3}>Spenningstyper</h3>
                    <div className={addProductCSS.subContainer1}>
                        <div>Flere spenningstyper</div>
                            <div className={`${serviceFormCSS.visuellSjekkButton} ${hasMultipleVoltageOptions ? serviceFormCSS.checked : ''}`} onClick={handleMulitpleVoltages}>
                                <div className={serviceFormCSS.running}></div>
                            </div>
                        </div>
                </div>

                {hasMultipleVoltageOptions && (
                    <>
                        <h3 className={updateFormCSS.h3}>Spenningstyper</h3>
                        {newVoltageOptions.map((option, index) => (
                            <div key={index} className={updateFormCSS.inputGroup}>
                                <input
                                    className={updateFormCSS.input}
                                    type="text"
                                    value={option.voltage}
                                    onChange={(e) => handleVoltageOptionsChange(index, e.target.value)}
                                    placeholder="Volt"
                                />
                                <button className={serviceFormCSS.removeButton} type="button" onClick={() => handleRemoveVoltageOption(index)}>Fjern</button>
                            </div>
                        ))}
                        <button className={`${serviceFormCSS.addButton2} bg-success text-white`} type="button" onClick={handleAddVoltageOption}>Legg til spenningstype</button>
                    </>
                )}
                    <h3 className={updateFormCSS.h3}>Service Skjema</h3>
                    <div className={updateFormCSS.visibilityContainer}>
                        <div className={updateFormCSS.visibilityChild1}>
                            Visuell sjekk
                        </div>
                        <div
                            className={`${updateFormCSS.visibilityChild2} ${visualChecked ? updateFormCSS.checked : ''}`}
                            onClick={() => setVisualChecked(!visualChecked)}
                        >
                            <div className={updateFormCSS.visibilityButton}></div>
                        </div>
                    </div>
                    {!visualChecked && (
                        <>
                            <div className={serviceFormCSS.categoryButtonDiv}>
                                <label>Kategori / underoverskrift</label>
                                <div className={serviceFormCSS.container5}>
                                    <input
                                        className={updateFormCSS.input}
                                        type="text"
                                        value={newCategoryName}
                                        onChange={handleCategoryNameChange}
                                        placeholder="Skriv inn kategorinavn"
                                    />
                                    <button
                                        className={`${serviceFormCSS.addButton2} bg-success text-white`}
                                        type="button"
                                        onClick={handleAddCategory}
                                    >
                                        Legg til Kategori
                                    </button>
                                </div>
                            </div>
                            {checks.map((check, index) => (
                                <div className={serviceFormCSS.container2} key={`${check.id}-${index}`}>
                                    <label>Sjekk nummer {index + 1}</label>
                                    <div className={updateFormCSS.container3}>
                                        <input
                                            className={`${updateFormCSS.input2} mt-2 mb-2`}
                                            type="text"
                                            value={check.description}
                                            onChange={e => handleCheckDescriptionChange(check.id, e.target.value)}
                                        />
                                        <button
                                            className={`${serviceFormCSS.removeButton} mt-1 mb-1`}
                                            type="button"
                                            onClick={() => handleRemoveCheck(check.id)}
                                        >
                                            Fjern
                                        </button>
                                        <div className={serviceFormCSS.container6}>
                                            <select
                                                value={check.category}
                                                onChange={e => handleCheckCategoryChange(check.id, e.target.value)}
                                            >
                                                <option value="">Velg kategori</option>
                                                {checkCategories.map(category => (
                                                    <option key={category.id} value={category.name}>
                                                        {category.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <button
                                className={`${serviceFormCSS.addButton2} bg-success text-white`}
                                type="button"
                                onClick={handleAddCheck}
                            >
                                Legg til sjekk
                            </button>
                        </>
                    )}
                    <button className={`${updateFormCSS.button} bg-primary text-white`} type="submit">Oppdater produkt</button>
                </form>
            </div>
        );
}

export default UpdateForm;
